import React from 'react'
import { Button, Form, Input, Modal, LocaleProvider } from 'antd'
import axios from 'axios'
const FormItem = Form.Item
import enUS from 'antd/lib/locale-provider/en_US';


class Login extends React.Component {
    constructor(props) {
        super(props);
        sessionStorage.clear();
        this.state = {
            switchFormRegister: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.checkChar = this.checkChar.bind(this);
    }

    onChangeEmail(event) {
        event.preventDefault();
        this.setState({ useremail: event.currentTarget.value.toLowerCase() })
    }

    checkChar(rule, value, callback) {
        if (!/@/.test(value)) {
            callback('Email is invalid');
        } else if (/@/.test(value)) {
            callback();
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        const gateSignIn = window.location.hostname === 'localhost' ? 'http://localhost:4050/auth/login' : 'http://servertuvanlogo.uplevo.com/auth/login';

        this.props.form.validateFieldsAndScroll((err, values) => {
            axios.post(
                gateSignIn, {
                    email: values.email,
                    password: values.password
                }).then(function (response) {
                    sessionStorage.setItem('role', response.data.user.role);
                    sessionStorage.setItem('id', response.data.user.id);
                    sessionStorage.setItem('code', response.data.user.code);
                    sessionStorage.setItem('username', response.data.user.username);
                    response.data.user.role === 'marketing_admin' || response.data.user.role === 'sale_admin' ?
                        window.location.replace('/')
                        :
                        window.location.replace('/stuff-contact-list');
                })
                .catch(function (error) {
                    Modal.warning({
                        title: "Uplevo System message",
                        content: "Email or password is incorrect"
                    })
                    console.log('error', error);
                });
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <LocaleProvider locale={enUS}>
                <div className="signin-form-wrap">
                    <div id="pageLogin" className='signin-form'>
                        <div className='form-logo'>
                            <img src="/images/logo.png" alt="Uplevo Login" />
                        </div>
                        <form>
                            <FormItem hasFeedback>
                                {getFieldDecorator('email', {

                                })(<Input size='large' onChange={this.onChangeEmail} onPressEnter={this.handleSubmit} placeholder='Email' />)}
                            </FormItem>
                            <FormItem hasFeedback>
                                {getFieldDecorator('password', {

                                })(<Input size='large' type='password' onPressEnter={this.handleSubmit} placeholder='Password' />)}
                            </FormItem>
                            <FormItem>
                                <Button id="btnLogin" type='primary' size='large' onClick={this.handleSubmit}>Login</Button>
                            </FormItem>
                            <p>
                                <a href="/signup">Create your new account? Sign up here</a>
                            </p>
                        </form>
                    </div>
                </div>
            </LocaleProvider>
        )
    }
}


export default Form.create()(Login);



// WEBPACK FOOTER //
// ./src/components/Admin/SignIn.js